import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function ProtectedRoute({ children }) {
  const { admin } = useAdminAuth();

  if (admin === null) {
    return (
      <div data-testid="admin-auth-checking" className="min-h-[60vh] flex items-center justify-center text-[#57534E]">
        <Loader2 className="animate-spin mr-2" size={18} /> Checking session…
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
